import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { RingLoader } from "react-spinners";
import Backicon from "../../../shared/components/Backicon/Backicon";
import Tile from "../../../shared/components/Tile/Tile";
import styles from "./insuranceprofile.module.css";
import baseStyles from "../../../shared/styles/basestyles.module.css";

function InsuranceProfile() {
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setPageLoading(false), 3000);
  }, []);

  return (
    <div className={styles.insurancehome}>
      <div className={baseStyles.container}>
        {pageLoading ? (
          <div className={styles.spinnerContainer}>
            <RingLoader size={100} color={"White"} />
          </div>
        ) : (
          <div>
            <Backicon onClick={() => this.props.history.goBack()} />
            <h1 className={styles.title}>Insurance Profile</h1>
            <div className={styles.first}>
              <Link to="/insurance/PatientsRecord">
                <Tile
                  name="Registered Patient's Record"
                  style={{
                    height: "200px",
                    width: "250px",
                    fontSize: "2.5rem",
                    backgroundColor: "rgba(255, 255, 255, 0.619)",
                  }}
                />
              </Link>
              <Link to="/insurance/ComplaintsAndMails">
                <Tile
                  name="Complaints And Mails"
                  style={{
                    height: "200px",
                    width: "250px",
                    fontSize: "2.5rem",
                    backgroundColor: "rgba(255, 255, 255, 0.619)",
                  }}
                />
              </Link>

              <Link to="/insurance/PatientsExpense">
                <Tile
                  name="Patient's Expense Report"
                  style={{
                    height: "200px",
                    width: "250px",
                    fontSize: "2.5rem",
                    backgroundColor: "rgba(255, 255, 255, 0.619)",
                  }}
                />
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default InsuranceProfile;
